var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbbEmptyEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 76.7662 76.7662",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 84",
    cx: 38.3831,
    cy: 38.3831,
    r: 38.3831,
    fill: "var(--fill-0, #F0F0F0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbbEmptyEllipse);
export default __webpack_public_path__ + "static/media/tbb-empty-ellipse.b46a196c4de901c76cff76221605f8a4.svg";
export { ForwardRef as ReactComponent };